
  var _styles = {
  "recommend3-price-info": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.50667rem",
    "height": "0.53333rem",
    "marginTop": "0.21333rem",
    "display": "flex",
    "justifyContent": "space-between",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "recommend3-price-img": {
    "width": "100%",
    "height": "2.53333rem",
    "borderTopLeftRadius": "0.06667rem",
    "borderTopRightRadius": "0.06667rem"
  },
  "recommend3-price-logo": {
    "borderRadius": "0.06667rem",
    "backgroundColor": "rgb(255,255,255)",
    "position": "relative"
  },
  "recommend3-label-img": {
    "position": "absolute",
    "top": "0.13333rem",
    "left": "0.13333rem",
    "height": "0.42667rem"
  },
  "recommend3-label-word": {
    "fontSize": "0.29333rem",
    "height": "0.53333rem",
    "paddingTop": "0.26667rem",
    "paddingRight": "0.16rem",
    "paddingBottom": 0,
    "paddingLeft": "0.16rem",
    "position": "absolute",
    "top": 0,
    "left": 0,
    "borderTopLeftRadius": "0.06667rem",
    "borderBottomRightRadius": "0.06667rem"
  },
  "recommend3-left-content": {
    "marginLeft": "0.4rem"
  },
  "recommend3-theme-city": {
    "fontSize": "0.45333rem",
    "color": "rgb(51,51,51)",
    "fontWeight": "bold"
  },
  "recommend3-right-content": {
    "marginRight": "0.4rem",
    "marginLeft": "0.13333rem"
  },
  "recommend3-font-grey": {
    "color": "rgb(134,134,134)"
  },
  "recommend3-font-blue": {
    "fontSize": "0.32rem",
    "color": "rgb(40,175,248)",
    "borderWidth": "solid",
    "borderStyle": "0.01333rem",
    "borderColor": "rgb(40,175,248)",
    "borderRadius": "0.05333rem",
    "paddingTop": 0,
    "paddingRight": "0.04rem",
    "paddingBottom": 0,
    "paddingLeft": "0.04rem",
    "height": "fit-content"
  },
  "recommend3-price": {
    "fontSize": "0.34667rem",
    "color": "rgb(254,117,104)"
  },
  "recommend3-price-inforecommend3-font-grey": {
    "fontSize": "0.34667rem",
    "marginTop": 0,
    "height": "0.66667rem"
  },
  "recommend3-num": {
    "fontSize": "0.53333rem",
    "color": "rgb(255,71,31)",
    "fontWeight": "bold"
  },
  "recommend3-btn-booking": {
    "fontSize": "0.4rem",
    "backgroundColor": "rgb(255,69,1)",
    "backgroundImage": "linear-gradient(90deg, #ff4501 15.3%, #ff7568 70.5%)",
    "color": "rgb(255,255,255)",
    "borderRadius": "1.33333rem",
    "paddingTop": "0.13333rem",
    "paddingRight": "1.2rem",
    "paddingBottom": "0.13333rem",
    "paddingLeft": "1.2rem",
    "marginTop": "0.24rem",
    "marginRight": "0.24rem",
    "marginBottom": "0.24rem",
    "marginLeft": "0.24rem",
    "height": "0.8rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  }
};



  module.exports = _styles;
  